<div class="header-topnav mat-elevation-z2">
	<div class="container">
		<div class="topnav">
			<!-- App Logo -->
			<div class="topbar-branding"><img src="assets/images/logo_protecta.png"
						 alt=""
						 class="app-logo" /></div>

			@if (!layoutConf.isMobile) {
			<ul class="menu">
				@for (item of menuItems; track item; let i = $index) {
				<li>
					@if (item.type !== 'separator') {
					<div routerLinkActive="open">
						@if (item.type === 'link') {
						<a matRipple
							 routerLink="/{{ item.state }}">
							<mat-icon>{{ item.icon }}</mat-icon>
							{{ item.name | translate }}
						</a>
						}
						@if (item.type === 'dropDown') {
						<div>
							<label matRipple
										 for="drop-{{ i }}"
										 class="toggle"><mat-icon>{{ item.icon }}</mat-icon> {{ item.name | translate }}</label>
							<a matRipple><mat-icon>{{ item.icon }}</mat-icon> {{ item.name | translate }}</a>
							<input type="checkbox"
										 id="drop-{{ i }}" />
							<ul>
								@for (itemLvL2 of item.sub; track itemLvL2; let j = $index) {
								<li routerLinkActive="open">
									@if (itemLvL2.type !== 'dropDown') {
									<a matRipple
										 routerLink="{{ item.state ? '/' + item.state : '' }}/{{ itemLvL2.state }}">
										@if (itemLvL2.icon) {
										<mat-icon>{{ itemLvL2.icon }}</mat-icon>
										}
										{{ itemLvL2.name | translate }}
									</a>
									}
									@if (itemLvL2.type === 'dropDown') {
									<div>
										<label matRipple
													 for="drop-{{ i }}{{ j }}"
													 class="toggle">{{ itemLvL2.name | translate }}</label>
										<a matRipple>@if (itemLvL2.icon) {
											<mat-icon>{{ itemLvL2.icon }}</mat-icon>
											} {{ itemLvL2.name | translate }}</a>
										<input type="checkbox"
													 id="drop-{{ i }}{{ j }}" />
										<!-- Level 3 -->
										<ul>
											@for (itemLvL3 of itemLvL2.sub; track itemLvL3) {
											<li routerLinkActive="open">
												<a matRipple
													 routerLink="{{ item.state ? '/' + item.state : '' }}{{ itemLvL2.state ? '/' + itemLvL2.state : '' }}/{{ itemLvL3.state }}">
													@if (itemLvL3.icon) {
													<mat-icon>{{ itemLvL3.icon }}</mat-icon>
													}
													{{ itemLvL3.name | translate }}
												</a>
											</li>
											}
										</ul>
									</div>
									}
								</li>
								}
							</ul>
						</div>
						}
					</div>
					}
				</li>
				}
			</ul>
			}
			<span class="header-top__spacer"></span>

			<button mat-button
							matTooltip="Tarifarios"
							(click)="toggleNotificSw()"
							[style.overflow]="'visible'"
							class="topbar-button-right tarifario">
				<mat-icon class="tarifario-icon">apps</mat-icon>
				<mat-label>{{ titleMenu() }}</mat-label>
			</button>


			<!-- Top left user menu -->
			<button mat-icon-button
							[matMenuTriggerFor]="accountMenu"
							class="topbar-button-right mr-1 img-button">
				<!-- 	<img src="assets/images/face-7.jpg" alt="" /> -->
				<mat-icon>menu</mat-icon>
			</button>
			<mat-menu #accountMenu="matMenu">
				@if (layoutConf.isMobile) {
				<button mat-menu-item
								[routerLink]="['/dashboard']">
					<mat-icon>account_box</mat-icon>
					<span>Inicio</span>
				</button>
				}

				<button mat-menu-item
								(click)="logout()">
					<mat-icon>exit_to_app</mat-icon>
					<span>Cerrar sesión</span>
				</button>
			</mat-menu>

		</div>
	</div>
</div>